import { createSelector } from 'reselect'

export const getDriverTimes = state => state.driverTimes.getIn(['all', 'objects'])

export const createGetDriverTimeByIDSelector = id => createSelector([getDriverTimes], driverTimes => driverTimes.get(String(id)))
